import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/footur";
import RectangleImage from "../assets/image/Rectangle.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStates,
  getMyActivityPoints,
  getMyActivityHistory,
} from "../redux/action/request";
import {
  FiActivity,
  FiCalendar,
  FiDollarSign,
  FiCheckCircle,
  FiClock,
} from "react-icons/fi";

const UserDashboard = () => {
  const dispatch = useDispatch();
  const [pendingPoints, setPendingPoints] = useState(0);
  const [issuedPoints, setIssuedPoints] = useState(0);

  const currentDate = new Date();
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const endOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );
  const [dateRange, setDateRange] = useState([startOfMonth, endOfMonth]);
  const [startDate, endDate] = dateRange;

  const statesData = useSelector((state) => state.auth.states);
  const activityPoints = useSelector((state) => state.auth.activityPoints);
  const pointsHistory = useSelector((state) => state.auth.pointsHistory);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    dispatch(getMyActivityPoints(userId));
    dispatch(fetchStates(userId));
    dispatch(getMyActivityHistory(userId, { startDate, endDate }));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    let issued = 0;
    let pending = 0;
    pointsHistory.forEach((item) => {
      const points = item?.paymentDetail?.activityPointsReceived || 0;
      item.paymentVarified ? (issued += points) : (pending += points);
    });
    setIssuedPoints(issued);
    setPendingPoints(pending);
  }, [pointsHistory]);

  const handleDateChange = (update) => {
    setDateRange(update);
    const userId = localStorage.getItem("userId");
    if (update[0] && update[1]) {
      dispatch(
        getMyActivityHistory(userId, {
          startDate: update[0],
          endDate: update[1],
        })
      );
    }
  };

  const statsCards = [
    {
      label: "Total Request",
      value: statesData?.totalRequests,
      icon: <FiActivity className="text-blue-500" size={24} />,
      bg: "bg-blue-50",
    },
    {
      label: "Request In Review",
      value: statesData?.requestInReviewTotal,
      icon: <FiClock className="text-amber-500" size={24} />,
      bg: "bg-amber-50",
    },
    {
      label: "Ready Quotation / Unpaid",
      value: statesData?.quotationMadeUnPaidTotal,
      icon: <FiDollarSign className="text-purple-500" size={24} />,
      bg: "bg-purple-50",
    },
    {
      label: "Ready Quotation / Paid",
      value: statesData?.quotationMadeAndPaidTotal,
      icon: <FiCheckCircle className="text-green-500" size={24} />,
      bg: "bg-green-50",
    },
    {
      label: "Policy Verified",
      value: statesData?.purchaseRequestTotal,
      icon: <FiCheckCircle className="text-indigo-500" size={24} />,
      bg: "bg-indigo-50",
    },
  ];

  return (
    <div className="bg-gray-50 min-h-screen font-sans">
      <Header />

      <section className="relative">
        
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative mt-8 sm:mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {statsCards.map((stat, i) => (
              <div
                key={i}
                className={`bg-white p-4 rounded-xl shadow-sm flex items-center gap-4 transition-transform hover:scale-[1.02]`}
              >
                <div className="p-3 rounded-full bg-gray-100">{stat.icon}</div>
                <div className="overflow-hidden">
                  <div className="text-lg sm:text-xl font-bold text-gray-800 truncate">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-500 font-medium truncate">
                    {stat.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <main className="max-w-7xl mx-auto mt-16 px-4 sm:px-6 lg:px-8 grid grid-cols-1 xl:grid-cols-3 gap-6">
        
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-semibold text-gray-800">
              Activity Points Summary
            </h3>
            <div className="p-2 rounded-lg bg-indigo-100">
              <FiActivity className="text-indigo-600" size={20} />
            </div>
          </div>

          <div className="text-center mb-8">
            <p className="text-5xl font-bold text-indigo-600 mb-2">
              {activityPoints?.totalActivityPoints}
            </p>
            <p className="text-sm text-gray-500">Total Points Earned</p>
          </div>

          <div className="space-y-4">
            <div className="flex justify-between items-center p-3 bg-blue-50 rounded-lg">
              <div className="flex items-center space-x-2">
                <FiCalendar className="text-blue-500" />
                <span className="text-sm text-gray-600">This Week</span>
              </div>
              <span className="font-semibold text-blue-700">
                {activityPoints?.lastWeekPoints}
              </span>
            </div>

            <div className="flex justify-between items-center p-3 bg-indigo-50 rounded-lg">
              <div className="flex items-center space-x-2">
                <FiCalendar className="text-indigo-500" />
                <span className="text-sm text-gray-600">This Month</span>
              </div>
              <span className="font-semibold text-indigo-700">
                {activityPoints?.lastMonthPoints}
              </span>
            </div>
          </div>
        </div>

       
        <div className="xl:col-span-2 bg-white p-6 rounded-xl shadow-sm border border-gray-100 overflow-x-auto">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-6 gap-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-800">
                Points History
              </h3>
              <p className="text-sm text-gray-500">
                Track your activity points and payouts
              </p>
            </div>

            <div className="flex flex-wrap gap-3 items-center">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-amber-100 text-amber-800">
                <FiClock className="mr-1" />
                Pending: {pendingPoints}
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                <FiCheckCircle className="mr-1" />
                Issued: {issuedPoints}
              </span>
              <div className="relative">
                <DatePicker
                  selected={startDate}
                  onChange={handleDateChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  className="border border-gray-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 w-full min-w-[200px]"
                  placeholderText="Select date range"
                />
                <FiCalendar className="absolute right-3 top-2.5 text-gray-400" />
              </div>
            </div>
          </div>

          <div className="overflow-x-auto rounded-lg border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200 text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">
                    Lead Detail
                  </th>
                  <th className="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">
                    Date
                  </th>
                  <th className="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">
                    Points
                  </th>
                  <th className="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">
                    Expected Payout
                  </th>
                  <th className="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {pointsHistory.length === 0 ? (
                  <tr>
                    <td
                      colSpan="5"
                      className="px-6 py-8 text-center text-gray-400"
                    >
                      <FiActivity className="mb-2 mx-auto" size={24} />
                      <p>No activity history found</p>
                      <p className="text-sm">Try adjusting your date range</p>
                    </td>
                  </tr>
                ) : (
                  pointsHistory.map((entry, idx) => (
                    <tr
                      key={idx}
                      className="hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <img
                            className="h-10 w-10 rounded-full object-cover"
                            src={entry?.paymentDetail?.companyLogo}
                            alt="Company logo"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "https://via.placeholder.com/40";
                            }}
                          />
                          <div className="ml-4">
                            <div className="font-medium text-gray-900">
                              {entry?.paymentDetail?.companyName || "N/A"}
                            </div>
                            <div className="text-gray-500">
                              ₹{entry?.paymentDetail?.premiumAmount || "0"} •{" "}
                              {entry?.registerNumber || "N/A"}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-gray-500">
                        {entry.paymentDate
                          ? new Date(entry.paymentDate).toLocaleDateString(
                              "en-GB"
                            )
                          : "N/A"}
                      </td>
                      <td className="px-6 py-4 font-medium text-gray-900">
                        {entry?.paymentDetail?.activityPointsReceived || "0"}
                      </td>
                      <td className="px-6 py-4 text-gray-500">
                        {entry?.expactedDate
                          ? new Date(entry.expactedDate).toLocaleDateString(
                              "en-GB"
                            )
                          : "N/A"}
                      </td>
                      <td className="px-6 py-4">
                        <span
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            entry.paymentVarified
                              ? "bg-green-100 text-green-800"
                              : "bg-amber-100 text-amber-800"
                          }`}
                        >
                          {entry.paymentVarified ? (
                            <>
                              <FiCheckCircle className="mr-1" /> Issued
                            </>
                          ) : (
                            <>
                              <FiClock className="mr-1" /> Pending
                            </>
                          )}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserDashboard;
